export enum PortfolioApprovalStatus {
  ACTIVE = 'Active',
  PENDING_NEW = 'PendingApprovalNew',
  PENDING_EDIT = 'PendingApprovalEdit',
  REJECTED_NEW = 'RejectedNew',
  REJECTED_EDIT = 'RejectedEdit'
}
